import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Sparkles, ArrowRight, X } from "lucide-react";
import { UI_EXTRA } from "@/data/uiExtra";

// Dismissible banner while at least one package is on promo (dismissal is per promo set).
export function PromoBanner({ tc, promoPkgs }) {
  const promoKey = "promo_dismissed_" + promoPkgs.map((p) => p.id).sort().join("_");
  const [dismissed, setDismissed] = useState(() => !!localStorage.getItem(promoKey));
  useEffect(() => { setDismissed(!!localStorage.getItem(promoKey)); }, [promoKey]);
  if (!promoPkgs.length || dismissed) return null;
  const dismiss = () => { localStorage.setItem(promoKey, "1"); setDismissed(true); };
  return (
    <div data-testid="promo-banner" className="relative overflow-hidden rounded-3xl border border-rose-300/40 bg-gradient-to-r from-rose-500/10 to-amber-400/10 p-4 sm:p-5 flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-4">
      <div className="flex items-center gap-3 min-w-0 flex-1 pe-8 sm:pe-0">
        <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl bg-rose-500 text-white"><Sparkles className="h-5 w-5" /></span>
        <div className="min-w-0 flex-1">
          <p className="font-medium text-sm">{tc(UI_EXTRA["promo.bannerTitle"])}</p>
          <p className="text-xs text-muted-foreground">{tc(UI_EXTRA["promo.bannerBody"]).replace("{n}", promoPkgs.length)}</p>
        </div>
      </div>
      <Link to="/packages" data-testid="promo-banner-view" className="shrink-0 inline-flex items-center justify-center gap-1.5 rounded-full bg-rose-500 text-white text-sm font-semibold px-4 h-11 sm:h-10 w-full sm:w-auto hover:opacity-90 transition-opacity">
        {tc(UI_EXTRA["promo.view"])} <ArrowRight className="h-4 w-4 rtl:-scale-x-100" />
      </Link>
      <button onClick={dismiss} data-testid="promo-banner-dismiss" aria-label={tc({ id: "Tutup", en: "Dismiss", ar: "إغلاق" })}
        className="absolute top-3 end-3 sm:static flex h-9 w-9 shrink-0 items-center justify-center rounded-full text-muted-foreground hover:text-foreground hover:bg-background/60"><X className="h-4 w-4" /></button>
    </div>
  );
}
